import { render, staticRenderFns } from "./AdminDashboardStatsSection.vue?vue&type=template&id=2055fd46&scoped=true&"
import script from "./AdminDashboardStatsSection.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardStatsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055fd46",
  null
  
)

export default component.exports